import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import request from "../../qnb/api/request";
export function createSubscription(_x) { return _createSubscription.apply(this, arguments); }
function _createSubscription() { _createSubscription = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) { var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return request.post("/api/v1/online/online/createSubscription", Object.assign({}, data, { inlineError: true, useSubmitTime: true }));
        case 2:
            resp = _context.sent;
            return _context.abrupt("return", resp.data);
        case 4:
        case "end": return _context.stop();
    }
} }, _callee); })); return _createSubscription.apply(this, arguments); }
export function createConsultation(_x2) { return _createConsultation.apply(this, arguments); }
function _createConsultation() { _createConsultation = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(data) { var resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return request.post("/api/v1/online/online/createConsultation", Object.assign({}, data, { inlineError: true, useSubmitTime: true }));
        case 2:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
        case 4:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _createConsultation.apply(this, arguments); }
export function createGroupPolicyContact(_x3) { return _createGroupPolicyContact.apply(this, arguments); }
function _createGroupPolicyContact() { _createGroupPolicyContact = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(data) { var resp; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            _context3.next = 2;
            return request.post("/api/v1/online/online/createGroupPolicyContact", Object.assign({}, data, { inlineError: true, useSubmitTime: true }));
        case 2:
            resp = _context3.sent;
            return _context3.abrupt("return", resp.data);
        case 4:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return _createGroupPolicyContact.apply(this, arguments); }
export function createPromotionQuestionnaire(_x4) { return _createPromotionQuestionnaire.apply(this, arguments); }
function _createPromotionQuestionnaire() { _createPromotionQuestionnaire = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(data) { var resp; return _regeneratorRuntime.wrap(function _callee4$(_context4) { while (1) {
    switch (_context4.prev = _context4.next) {
        case 0:
            _context4.next = 2;
            return request.post("/api/v1/online/online/createPromotionQuestionnaire", Object.assign({}, data, { inlineError: true, useSubmitTime: true }));
        case 2:
            resp = _context4.sent;
            return _context4.abrupt("return", resp.data);
        case 4:
        case "end": return _context4.stop();
    }
} }, _callee4); })); return _createPromotionQuestionnaire.apply(this, arguments); }
